export function compareInstanceTypes(a: MachineInstanceType, b: MachineInstanceType) {
  if (a.cpu_cores != b.cpu_cores) {
    return a.cpu_cores - b.cpu_cores;
  }

  if (a.cpu_memory != b.cpu_memory) {
    return a.cpu_memory - b.cpu_memory;
  }

  return a.price_per_unit - b.price_per_unit;
}

export function compareGPUInstanceTypes(a: MachineInstanceType, b: MachineInstanceType): number {
  if (a.gpu_count != b.gpu_count) {
    return a.gpu_count - b.gpu_count;
  }

  if (a.gpu_memory != b.gpu_memory) {
    return a.gpu_memory - b.gpu_memory;
  }

  if (a.cpu_cores != b.cpu_cores) {
    return a.cpu_cores - b.cpu_cores;
  }

  if (a.cpu_memory != b.cpu_memory) {
    return a.cpu_memory - b.cpu_memory;
  }

  return a.price_per_unit - b.price_per_unit;
}
